/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Ben_CtaInputs */

const en_funnel_ob_ben_cta = /** @type {(inputs: Funnel_Ob_Ben_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, that's me`)
};

const es_funnel_ob_ben_cta = /** @type {(inputs: Funnel_Ob_Ben_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí, ese soy yo`)
};

/**
* | output |
* | --- |
* | "Yes, that's me" |
*
* @param {Funnel_Ob_Ben_CtaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_ben_cta = /** @type {((inputs?: Funnel_Ob_Ben_CtaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Ben_CtaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_ben_cta(inputs)
	return en_funnel_ob_ben_cta(inputs)
});